import React from 'react'
import './blogs.css'
const Vishal_Agarwal = () => {
    return (
        <div className='blog'>
            <div className='container-fluid'>
                <div className='row blog-row'>
                    <div className='col-md-4'>
                        <img src='placement-postulates/dp/Vishal-Agarwal.jpg' className='blog-dp' alt='Vishal'></img>
                    </div>
                    <div className='col-md-8'>
                        <div className='blog-head'>
                            <h2>Vishal Agarwal</h2>
                            <small></small>
                        </div>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className='row'>
                        <div>
                        <p>Hi there,<br/>
        My name is Vishal Agarwal (Y17, CE), currently placed at MTX Group and today I am going to give you a
        student’s perspective, something really honest and straightforward because that’s an element often missing
        in the talks that are given by the companies. I’m just currently a student like all of you and the things I
        am going to talk about will admittedly be anecdotal.
      </p>
      <p>
        Some of the firms that I have interviewed with include BlackRock, Capital One, Deskera, Finmechanics, MTX
        Group, Oracle and Standard Chartered. So, I think I have a fair amount of interview experience and I’m sure
        that there are more experienced and smarter people that should be giving advice instead of me but I want to
        help out those who don’t even know where to start and are new to the interviewing game.
      </p>
      <p>
      <h2><u>It’s Simple but not Easy</u></h2>
      Well, It’s quite simple to get a job. The mantra can be broken down into two steps -<br/>
      <span>&#9733;</span> Step 1 - Getting an interview<br/>
      <span>&#9733;</span> Step 2 - Doing well in the interview<br/>
      <img class="blog-image-left" src="placement-postulates/blogs/Vishal-Agarwal/1.jpg"/>Now, I know most of
      you are thinking, well wasn’t that obvious. But see,
      that’s just the thing for getting placed. I said it's simple, but I didn’t say It was easy.<br/><br/>
      So let’s talk about Step 1, Getting an interview. To get an interview you first need to apply with a resume,
      here’s the link to <a class="links"
        href="https://drive.google.com/file/d/1Skc0lbwli0Fl7_o10eIUVXzNNU15GfMD/view?usp=sharing"
        target="_blank">mine</a>.<br/><br/>
      It’s a fact that recruiters who come to our campus spend a max of 10 seconds screening the applicant’s resume so
      each line you put in your resume should speak out - “Why should we hire this person?”.<br/><br/>
      Get your resume reviewed by several seniors and peers so that you can improve upon your points. You need to make
      each line stand out on its own and the best way to do so is to keep working on them. Set aside around 2 weeks
      for resume preparation.
      </p>
      <p>
      <h2><u>It’s never late to start</u></h2>
      We are a very lucky generation, to be honest, we have access to technology as well as what the professionals in
      the industry have access to. So nothing is stopping us to work on personal projects.<br/><br/>
      <img class="blog-image-right" src="placement-postulates/blogs/Vishal-Agarwal/2.jpg"/>A personal project
      can be anything you like and you need to just keep working
      on projects like it and with consistency, you will be able to produce that ‘single project’ which is good enough
      for you to get shortlisted.<br/><br/>
      Also, personal projects are a great way to showcase to the recruiters that you are passionate about what you
      like doing, even more than what an average internship may speak for.
      </p>
      <p>
      <h2><u>I never did a formal DSA Course</u></h2>
      The funny thing about my academic background is that I never did any formal DSA course offered by the institute
      and have a ‘C’ grade in the introductory ESC101 course.<br/><br/>
      But to get interviews after getting shortlisted you need to clear the Coding/Aptitude round and for that, both
      of the above are considered to be quite important. But as I said there’s nothing you can practice for, I started
      my placement preparation in late July (It’s better to start early for sure) and from my experience of internship
      season, Tech companies are more concerned about how good you can solve complex questions rather than simple ones
      (they don’t exist in most of the companies paper).<br/><br/>
      <img class="blog-image-left" src="placement-postulates/blogs/Vishal-Agarwal/3.jpg"/> But to solve these
      complex questions one does not need to be very good at DSA
      but they just need to know the method as to ‘how to de-construct the question into smaller ones?’. This can be
      learned by practicing questions of different types from platforms like Interviewbit and leetcode. Stick to any
      of the available platforms and don’t deviate.<br/><br/>
      Don’t get stuck in following the formal way of first learning about DSA concepts (If you already know them, it's
      a plus) and then doing all the practice, just dive into these platforms you will automatically know which
      concepts to pick up as you practice them.
      </p>
      <p>
      <h2><u>We all are good at Aptitude</u></h2>
      It’s quite true that we all are good at aptitude but to get the interviews you need to have that extra edge over
      others, so practice from CAT Papers and pick up tricks from TIME resources which are freely available on the
      internet.
      <br/><br/><img class="blog-image-right" src="placement-postulates/blogs/Vishal-Agarwal/4.jpg"/>
      Don’t bother too much about this section. It will hardly take 2 weeks to get quite good in this section. I did
      my preparation for this section in early September (try to schedule it as close to the placement exams so that
      you are fresh with the tricks).
      </p>
      <p>
      <h2><u>Acing the Interview</u></h2>
      Now, Once you have made it to the interviews, and believe me, you have won half the battle. To ace in your
      interview try presenting your story in such a way that it resonates with either the role you are interviewing
      for or the company’s motto.
      <br/><br/>
      It’s obvious that all your peers who are shortlisted alongside you for the role are good enough for the company
      to be said ‘Technically sound’. Now the only thing you need to do is to stand by it and make yourself
      ‘memorable’.
      <br/><br/><img class="blog-image-left" src="placement-postulates/blogs/Vishal-Agarwal/5.jpg"/>
      Try to drive your way into your strong points included in your resume or if there are no strong enough points on
      your resume which you are not confident talking about, try to talk about things that are not on your resume and
      relate it to the company's belief (That’s why company talks are important to attend).
      <br/><br/>
      I drove my interview into the strong points of my resume during my interview with MTX Group.
      <br/><br/>
      The process consisted of two technical interviews (45 minutes each) in which you are expected to be thorough
      with DSA and DBMS. There can be some discussion over the listed projects or internship experience but majorly
      they test on famous DSA and DBMS problems. For these rounds focus on GFG’s top 50 questions and show your
      approach to the given problem constructively.
      <br/><br/>
      Then it is followed by a CIO and CEO round (each varies from 20 - 30 mins) which is interaction with the higher
      management to test out leadership skills, ownership, etc. Here try to move their attention indirectly to your
      strong points in terms of skills that are not technical.
      <br/><br/>
      If the Interviewer plays along with you then you are most probably going to get the job and if the interviewer
      does not play along then it's okay, just move on to your next interview.
      </p>
      <p>
      <h2><u>Handling Stress</u></h2>
      Stress is something we all have faced, be it mid-sem stress or end-sem stress to save the course. But the
      placement stress has its place, way higher than all of the above.
      <br/><br/>
      But one thing which is common in any form of stress is that it does go away one day if we just keep working
      hard.
      <br/><br/><img class="blog-image-right" src="placement-postulates/blogs/Vishal-Agarwal/6.jpg"/>
      I admit I had my fair amount of stress, be it not getting shortlisted to even giving tests due to branch
      barriers or not getting shortlisted due to the CPI barrier or not getting shortlisted for interviews, and many
      more.
      <br/><br/>
      But the only thing you can rely on is your way of handling the stress.
      <br/><br/>
      I used to talk to my friends after every paper to criticise the company and a weekly Video-call with them to
      listen to each other's issues and give constructive criticism to each other’s approach.
      <br/><br/>
      Believe in yourself and don’t let stress break you, this experience is a learning experience for everyone so
      take it positively and keep working hard.
      </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Vishal_Agarwal